import { invokeGetFileFromServer } from '@/services/invoke-get-file-service';
import filesUtils from '@/utils/files-utils';


const IMAGE_MIME_TYPES = ['image/png', 'image/jpg', 'image/jpeg'];
const PREVIEWABLE_MIME_TYPES = [...IMAGE_MIME_TYPES, 'application/pdf'];

export function isImage(file) {
    return IMAGE_MIME_TYPES.includes(file.data.mimeType);
};

export  function isPreviewable(file) {
  return PREVIEWABLE_MIME_TYPES.includes(file.data.mimeType);
};

export async function handlePreviewItem(item) {
  if (!isPreviewable(item))
    return;

  if (isImage(item))
    await this.$refs.imagePreviewDialog.open(item);
  else
    handlePreviewDocument(item);
};

async function handlePreviewDocument(file) {
  try {
    const response = await invokeGetFileFromServer(file);
    filesUtils.previewPdf(
      response.data,
      file.data.pathName,
      file.data.mimeType
    );
  } catch (e) {
    throw e;
  }
}